import { useNavigate } from 'react-router';
import { EppRedeemTerminateRequestType } from '../../generated/api/eppRedeemTerminateRequestType';
import { closeDialog, setDialogSubmitFailed, setDialogSubmitting } from '../../public/site/dialogStore.js';
import { addNotification } from '../../public/site/notificationStore.js';
import { paths } from '../constants/pathVariables';
import { postEppRedeemTerminate } from '../fetch';
import { t } from '../i18n';
import { useSearchParams } from './useSearchParams';
import type { DeliveryAddress } from '../../generated/api/deliveryAddress';
import type { PostEppRedeemTerminateRequest } from '../../generated/api/postEppRedeemTerminateRequest';
import type { Subscription } from '../../generated/api/subscription';

export const useEppDestroyedOrMissing = (
  sub: Subscription
): ((requestType: EppRedeemTerminateRequestType, address?: DeliveryAddress) => void) => {
  const navigate = useNavigate();
  const { mdmId } = useSearchParams<{ mdmId: string }>();

  return async (requestType: EppRedeemTerminateRequestType, address: DeliveryAddress) => {
    try {
      const payload: PostEppRedeemTerminateRequest = {
        requestType,
        destroyed: requestType === EppRedeemTerminateRequestType.DESTROYED ? { address } : undefined,
      };

      setDialogSubmitting(true);
      await postEppRedeemTerminate(sub.subscriptionId, payload, mdmId);
      addNotification(t.DUFL('Your service request was sent successfully'));
      closeDialog();
      navigate(paths.PS_DEVICES);
    } catch {
      setDialogSubmitFailed();
    }
  };
};
